// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, type = 'auth' }) => {
  const { authToken, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>; // o un spinner
  }

  if (type === 'auth' && !authToken) {
    return <Navigate to="/login" replace />;
  }

  // Gesitón de Cobros
  if (type === 'collections' && process.env.REACT_APP_ALLOW_COLLECTION_MANAGEMENT !== 'true') {
    return <Navigate to="/" replace />;
  }

  // Gestión de Reportes Z
  if (type === 'zreports' && process.env.REACT_APP_ENABLE_ZREPORT_MANAGEMENT !== 'true') {
    return <Navigate to="/" replace />;
  }

  // Gestión de Documentos
  if (type === 'documents' && process.env.REACT_APP_ENABLE_DOCUMENT_UPLOAD === 'false') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
